var f = "/static/ba1ad34706595751.png";

export { f as default };
//# sourceMappingURL=vip_reload.png.js.map
